import { render } from "./FooterComponent.vue?vue&type=template&id=f4f66cae&scoped=true&ts=true"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"

import "./FooterComponent.vue?vue&type=style&index=0&id=f4f66cae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f66cae"]])

export default __exports__